import { FastCheckoutActionTypes } from './fastcheckout.types';


const initialState = {
  loading: false,
  product: {
    error: false,
    id: null,
    name: null,
    cycles: [],
    discount: {
      value: null,
      type: null,
      percentage: null,
    },
    vat: {
      name: null,
      value: null,
      percentage: null,
      amount: null,
    },
    totalValue: null,
    price: null,
    priceWithVat: null,
    renewalDate: null,
    paymentMethods: [],
    installments: [],
  },
  purchase: {
    error: false,
    success: false,
  },
};

const fastCheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case FastCheckoutActionTypes.SET_FASTCHECKOUT_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case FastCheckoutActionTypes.SET_FAST_CHECKOUT_PRODUCT:
      return {
        ...state,
        product: action.payload.product,
      };
    case FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PRODUCT_FAILURE:
      return {
        ...state,
        product: {
          ...state.product,
          error: true,
        },
      };
    case FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE_SUCCESS:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          success: true,
        },
      };
    case FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE_SET_ERROR:
      return {
        ...state,
        purchase: {
          ...state.purchase,
          error: action.payload.error,
        },
      };
    case FastCheckoutActionTypes.FASTCHECKOUT_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default fastCheckoutReducer;
